angular.module('dpw.directives').directive('dpwFloatingElement', [function () {
    return {
        restrict: 'A',
        scope: {
            position: '@',
            spacing: '<', // spacing between the floating element and the top edge or bottom edge of window
            priority: '<'
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: ['$window', '$timeout', '$element', 'ElementPlaceholder', 'helpers',
            function ($window, $timeout, $element, ElementPlaceholder, helpers) {
                var self = this;
                self.position = _.includes(['top', 'bottom'], self.position) ? self.position : 'top';
                self.spacing = self.spacing || 0;
                self.priority = self.priority || 0;
                self.classNameIsFloating = 'dpw-floating-element-is-floating';
                self.nativeElement = $element[0];

                self.$postLink = function () {
                    $timeout(function () {
                        self.placeholder = ElementPlaceholder.create(self.nativeElement);
                        $element.after(self.placeholder.get());
                        self.resolve();
                        $window.addEventListener('scroll', self.resolve);
                    });
                };

                self.$onDestroy = function () {
                    $window.removeEventListener('scroll', self.resolve);
                };

                self.resolve = function () {
                    self.shouldFloat() ? self.enableFloating() : self.disableFloating();
                };

                self.enableFloating = function () {
                    self.placeholder.show();
                    $element.addClass(self.classNameIsFloating);
                    $element.css('z-index', self.priority);
                    $element.css(self.isPositionedOnTop() ? 'top' : 'bottom', self.spacing + 'px');
                };

                self.disableFloating = function () {
                    self.placeholder.hide();
                    $element.removeClass(self.classNameIsFloating);
                    $element.css({
                        'top': '',
                        'bottom': '',
                        'z-index': ''
                    });
                };

                self.shouldFloat = function () {
                    if (self.isPositionedOnTop()) {
                        return $window.pageYOffset >= self.getOffsetTopRelativeToRoot() - self.spacing;
                    }

                    return (
                        $window.pageYOffset + $window.innerHeight <=
                        self.getOffsetTopRelativeToRoot() + self.nativeElement.getBoundingClientRect().height + self.spacing
                    );
                };

                self.getOffsetTopRelativeToRoot = function () {
                    return Math.max(
                        helpers.getOffsetTopRelativeToRoot(self.nativeElement),
                        helpers.getOffsetTopRelativeToRoot(self.placeholder.get())
                    );
                };

                self.isPositionedOnTop = function () {
                    return self.position === 'top';
                };
            }]
    };
}]);